
export default {
  name: 'TheFooter',
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      return this.white
        ? 'text-black text-opacity-50 bg-white '
        : 'bg-primary text-white '
    }
  }
}
